import { useTheme } from "@repo/forms-ui";
import { Link } from "@tanstack/react-router";
import type React from "react";

export default function Index() {
  const { mode, setMode, accent, setAccent } = useTheme();
  const onAccentChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    const v = e.target.value as "blue" | "violet" | "green" | "orange";
    setAccent(v);
  };
  return (
    <main className="container">
      <header className="app-header">
        <div style={{ display: "grid", gap: 6 }}>
          <span className="pill">InstaLaw</span>
          <h1 style={{ margin: 0, letterSpacing: "-0.02em" }}>Client Portals</h1>
          <p className="muted">Publish sleek client-facing pages with your brand’s accent.</p>
        </div>
        <div className="toolbar">
          <button
            type="button"
            className="btn muted"
            onClick={() => setMode(mode === "light" ? "dark" : "light")}
            aria-label="Toggle theme"
          >
            {mode === "light" ? "☾ Dark" : "☀︎ Light"}
          </button>
          <select
            aria-label="Accent"
            value={accent}
            onChange={onAccentChange}
            className="btn ghost"
            style={{ padding: "10px 12px" }}
          >
            <option value="blue">Blue</option>
            <option value="violet">Violet</option>
            <option value="green">Green</option>
            <option value="orange">Orange</option>
          </select>
          <a className="btn" href="https://github.com" target="_blank" rel="noreferrer">Docs</a>
        </div>
      </header>

      <section className="hero" style={{ marginTop: 12 }}>
        <div className="hero-inner">
          <h1>Welcome to Portals</h1>
          <p>Fast to configure. Comfortable to use. Beautiful by default.</p>
          <div className="toolbar" style={{ marginTop: 10 }}>
            <Link
              to="/portals/$org/$slug"
              params={{ org: "acme", slug: "client-portal" }}
              className="btn"
            >
              View Sample Portal
            </Link>
            <a className="btn ghost" href="/">Explore</a>
          </div>
        </div>
      </section>

      <section style={{ marginTop: 24 }} className="grid cols-3">
        <article className="card">
          <div className="card-header">
            <div className="card-title">Configure</div>
            <div className="card-desc">Define blocks and theme accents</div>
          </div>
          <div className="card-body">
            <p className="muted">Point your portal to published or draft configuration.</p>
          </div>
          <div className="card-footer">
            <Link
              className="btn"
              to="/portals/$org/$slug"
              params={{ org: "acme", slug: "client-portal" }}
            >Open Portal</Link>
          </div>
        </article>
        <article className="card">
          <div className="card-header">
            <div className="card-title">Preview</div>
            <div className="card-desc">Switch between draft and published</div>
          </div>
          <div className="card-body">
            <p className="muted">Use a simple query param to toggle draft view.</p>
          </div>
          <div className="card-footer">
            <a className="btn ghost" href="/portals/acme/client-portal?draft=true">Draft</a>
          </div>
        </article>
        <article className="card">
          <div className="card-header">
            <div className="card-title">Integrate</div>
            <div className="card-desc">Link to forms, uploads and more</div>
          </div>
          <div className="card-body">
            <p className="muted">Blocks support hero intros and lists of links.</p>
          </div>
          <div className="card-footer">
            <span className="kbd">/portals/$org/$slug</span>
          </div>
        </article>
      </section>
    </main>
  );
}
